export const sendPicsInitFormDataEffect =
  (form, setForm, propertyId, property) => () =>
    setForm({
      ...form,
      propertyId,
    });
